import { useEffect, useState } from "react";
import { useAppSelector } from "../../stateManagement/hooks/redux";
import { highlightSearchValueInText } from "../../features/textHighlighter/textHighlighter";
import { RoadWithPathsItem } from "./RoadWithPathsItem";
import { PathItem } from "./PathItem";

const itemIsExpandedIcon = require('../../assets/images/icons/down_icon_dark.png')
const itemIsNotExpandedIcon = require('../../assets/images/icons/forward_icon.png')

type RoadsListRoadWithPathsItemProps = {
    raionId: string,
    raionName?: string,
    roads: any
}

// Компонент - объект с наименованием дороги и направления на странице "Выбор дорог и направлений"
export function RaionWithRoadsItem({ raionId, roads, raionName }: RoadsListRoadWithPathsItemProps) {
    const { selectedPath, pathsSearchValue } = useAppSelector(state => state.pathsInfo)
    const [isExpanded, setIsExpanded] = useState<boolean>(raionId == selectedPath?.raionId)

    useEffect(() => {
        if (pathsSearchValue) {
            setIsExpanded(true)
        }
    }, [pathsSearchValue])

    return (
        <>
            <div className="roads-list-raion-item" onClick={() => setIsExpanded(!isExpanded)}>
                <img className={"expand-state-icon" + (isExpanded ? ' expanded' : ' not-expanded')} src={isExpanded ? itemIsExpandedIcon : itemIsNotExpandedIcon} />
                <span className='raion-name'>{highlightSearchValueInText(raionName, pathsSearchValue)}</span>
            </div>
            {isExpanded &&
                <div>
                    {roads.map(({roadId, roadName, paths}: any) =>
                        <>
                            {paths.length > 1 &&
                                <RoadWithPathsItem key={`road-${roadId}`} roadId={roadId} roadName={roadName} paths={paths} isInRaion raionId={raionId}/>
                            }
                            {paths.length === 1 &&
                                <PathItem key={`path-${paths[0]?.PathID}`} path={paths[0]} isInRaion raionId={raionId}/>
                            }
                        </>
                    )}
                </div>
            }
        </>
    );
}

